
const userTempRegister = {
  rutValid: false,
  messageRutCompany: null,
  numCompanyRequest: 0,
};

export default userTempRegister;

